import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

import ClientAppForm from '@/components/ClientApps/ClientAppForm/ClientAppForm.vue';
import Loader from '@/components/Includes/Loader/Loader.vue';
import {Action} from 'vuex-class';

import IClientApp from "@/interfaces/IClientApp";
import cloneObject from "@/libs/cloneObject";

import {VPN} from "@/../configs/prefixesAPI";

@Component({
    components: {
        Loader,
        ClientAppForm
    }
})

export default class ClientAppDetail extends Vue {
    @Prop(String) private modalId!: string;
    @Prop(String) private modalTitle!: string;
    @Prop({type: Boolean, default: false}) private hideFooter!: boolean;
    @Prop(Boolean) private showModal!: boolean;
    @Prop(Object) private sourceData!: IClientApp;

    @Action private clientAppUpdate!: (form: IClientApp) => Promise<string>;
    @Action private subscriptionsClientAppUpdate!: (form: IClientApp) => Promise<string>;

    private loading: boolean = true;

    private show: boolean | null = null;

    private get isSubscriptions() {
        return this.$route.name === 'subscriptions_client_apps_list';
    }

    @Watch('showModal')
    private toggleModal(): void {
        this.show = this.showModal;
    }

    private closeModal() {
        this.$emit('closeModalClientApp')
    }

    private checkValidValues() {
        (this.$refs.clientAppForm as HTMLFormElement).handleSave()
    }

    private async updateClientApp(form: IClientApp) {
        try {
            this.loading = true;

            const data = {...form};

            data.domain = data.domain || null;

            if (Array.isArray(data.vpnServers)) {
                data.vpnServers = cloneObject(form).vpnServers.map((vpn: { value: number }) => `${VPN}${vpn.value}`)
            }

            const changeStatus = await this[this.isSubscriptions ? 'subscriptionsClientAppUpdate' : 'clientAppUpdate'](data);

            if (changeStatus === 'success') {
                this.loading = false;

                this.closeModal();

                this.$emit('UpdateClientApps');

                this.$notify({
                    group: 'notice',
                    title: `Client App ${form.name}`,
                    text: 'Updated Successfully',
                    type: 'success'
                });
            } else {
                this.loading = false;
            }
        } catch (error) {
            throw new Error(error)
        }
    }

    private mounted() {
        this.loading = false;
    }
}
